var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPriorities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9C00ED35-D763-4151-9C53-140C8BF1FAE7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,0 L1.6,0 C0.72,0 0,0.72 0,1.6 L0,16 L3.2,13 L14.4,13 C15.28,13 16,12.28 16,11.4 L16,1.6 C16,0.72 15.28,0 14.4,0 Z M3,3 L5,3 L5,10 L3,10 L3,3 Z M6,6 L8,6 L8,10 L6,10 L6,6 Z M9,4 L11,4 L11,10 L9,10 L9,4 Z M12,8 L14,8 L14,10 L12,10 L12,8 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "investment-viewfinder-priorities",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "priorities",
    transform: "translate(-147.000000, -158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "priorities",
    transform: "translate(135.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box/title"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDBC-Icon",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_priorities",
    fill: "#255EBA",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-2)",
    fill: "#8A8888"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -4.000000)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPriorities);
export default __webpack_public_path__ + "static/media/ic_priorities.8aba4e3f8c5f81d2dde9ed8dc02c5085.svg";
export { ForwardRef as ReactComponent };